module.exports = __webpack_public_path__ + "media/components/web/pages/static_pages/resources/not_found_image_mobile-cd11228079fe260eb32b82ac204cac73.svg";